import { Component, OnInit } from '@angular/core';
import { actionTypeOptions, joinTypeOptions, operatorOptions, isData, getWhereOperator, getAndOrOperator, isBlank, booleanOptions, pageTypeOptionsAdmin } from 'src/app/utils/utils';
import { FormGroup, FormBuilder, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { SrcPath } from 'src/app/constants/srcPath';
import { ColumnHeader } from 'src/app/models/column-header';
import { Labels } from 'src/app/constants/labels';
import { CommonService } from 'src/app/services/common-service/common.service';
import { KEYS } from 'src/app/constants/keys';
import { PageDetails } from 'src/app/models/page-details';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { isNullOrUndefined } from 'is-what';
import { CommonModule } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';


@Component({
  selector: 'app-page-workflow',
  imports: [CommonModule,NgSelectComponent,ReactiveFormsModule],
  templateUrl: './page-workflow.component.html',
  styleUrls: ['./page-workflow.component.scss']
})
export class PageWorkflowComponent
  implements OnInit {
  public isMailMerge: any = false;
  pageWorkflowForm: FormGroup | any;
  layOutData: any;
  public mm_columns_list: any = [];
  allControls: any = [];
  actionTypeOptions = actionTypeOptions;
  pageTypeOptions = pageTypeOptionsAdmin;
  headerData: ColumnHeader | any;
  srcPath = SrcPath;
  submitted: boolean = false;
  labelName = Labels.pageWorkflow;
  dynamicTableList: any = [];
  isSuperaDmin: boolean = false;
  dbPath: any;
  pvColumnsList: any = {};
  pvAllColumns: any = [];
  actions: any = [];
  JoinTypeOptions = joinTypeOptions;
  operatorOptions = operatorOptions;
  generatedSqlQuery: string | any;
  pageDetails: PageDetails | any;
  pageId = 0;
  tableName = '';
  labelMessages = Labels.messages.page_workflow;
  labelMessagesMsg = Labels.messages;
  allPageList = [];
  booleanOptions = booleanOptions;
  saveNextPageFlag = 0;
  bsModalRef!: BsModalRef;
  dynamicTables = [];
  tableColumns = [];
  pageTable = '';
  pageTblPrkey = '';
  generatedSqlQueryMM: string | any;
  public parent_columns_list: any = [];
  messageLabel = Labels.messages;

  constructor(private formBuilder: FormBuilder,
    private modalRef: BsModalRef,
    private modalService: BsModalService,
    private commonService: CommonService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.pageDetails = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!);
    this.pageId = this.pageDetails.pageId;
    this.getPageTablenameAndPrimaryKey();
    //this.checkIfMailMerge();
    this.getMenusByModuleId();
    this.getTableName();
    this.isSuperAdmin()
    this.initColumnHeader();
    this.getColumnFromTable();
    this.initializeFormData();
    this.loadTableList();
    this.allControls = this.commonService.getControlsForPageWorkflow();
    this.actions = actionTypeOptions;
    this.loadAllData();
    this.loadUserWorkflow();
    this.loadMailMergeData();
    this.loadoutlookworkflow();
  }

  getPageTablenameAndPrimaryKey() {
    this.commonService.getPageTablenameAndPrimaryKey(this.pageId).subscribe((data: any) => {
      if (data['table'].length > 0) {
        this.pageTable = data['table'][0].tblname;
        this.pageTblPrkey = data['table'][0].primarykey;
      }
    });
  }

  checkIfMailMerge() {
    let arrayInfo = this.commonService.layoutArrayInfo;
    let topbuttonlayout = arrayInfo[0].layoutControls;
    this.isMailMerge = false;
    topbuttonlayout.forEach(item => {
      this.commonService.ogLog("Item:", item);
      if (this.isMailMerge == false && item.gstibo_top_button_functionality == "MailMerge") {
        this.isMailMerge = true;
      }
    });
  }

  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }

  private initColumnHeader() {
    this.headerData = {
      title: this.labelName.title,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.labelName.title,
            icon: SrcPath.saveIcon,
            class: this.labelName.class
          }
        ]
      }
    };
  }

  initializeFormData() {
    this.pageWorkflowForm = this.formBuilder.group({
      selectedColumns: this.formBuilder.array([this.InitializeInnerArrays()]),
      displayName: [''],
      isFirstPage: ['false'],
      pageType: [],
      saveNextPage: ['false'],
      nextPageId: [''],
      lnkTableName: [''],
      columnName: [''],
      selectedColumnsMM: this.formBuilder.array([this.InitializeInnerArraysMM()]),
      sqlQueryMM: [''],
      parenttableName: [''],
      parentPrColName: [],
      isOutlookPage: ['false'],
      iseCabinetPage: ['false'],
      applyuserrights: ['false']
    });
  }

  InitializeInnerArrays() {
    return this.formBuilder.group({
      controlName: null,
      actionName: null,
      sqlQuery: null,
      whereCondition: this.formBuilder.array([this.InitializeWhereCondition()])
    });
  }

  getWhereCondition(form: any) {
    return form.controls.whereCondition.controls;
  }

  InitializeWhereCondition() {
    return this.formBuilder.group({
      columnName: null,
      operator: null,
      value: null,
      condition: null
    });
  }

  deleteUserWorkflow() {
    
    const modaldata = {
      title: this.labelMessagesMsg.delete_confirm_msg.title,
      message: this.labelMessagesMsg.delete_confirm_msg.message,
      btnConfirm: this.labelMessagesMsg.delete_confirm_msg.btnDelete,
      btnCancel: this.labelMessagesMsg.delete_confirm_msg.btnCancel,
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.commonService.showConfirmationModal(modaldata.title, modaldata.message, modaldata.message, modaldata.btnConfirm, modaldata.btnCancel, KEYS.dialogueType.DELETE).subscribe((res: any) => {
      if (res) {
        this.commonService.deleteUserWorkflow(this.pageId).subscribe((data: any) => {
          if (data['table'].length > 0) {
            let retval = data['table'][0].retval;
            if (retval == 1) {
              this.saveNextPageFlag = 0;
              this.pageWorkflowForm.patchValue
                ({
                  isFirstPage: 'false',
                  displayName: [''],
                  pageType: 3,
                  saveNextPage: 'false',
                  nextPageId: 0,
                  lnkTableName: [''],
                  columnName: ['']
                });
             // this.toastr.success(this.labelMessages.delete_success_user);
              this.commonService.showModalValidate(this.labelMessages.delete_success_user, '', this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg);
            }
          }
        });
      }
    });
  }

  closeModal() {
    this.modalRef.hide();
  }

  onSubmit() {
    this.savePageWorkflowData(this.pageWorkflowForm.value, this.pageId, this.tableName);
  }

  deleteMainControl(cIndex: any) {
    const selectedColumns = <FormArray>this.pageWorkflowForm.get('selectedColumns');
    selectedColumns.removeAt(cIndex);
    selectedColumns.updateValueAndValidity();
    //this.toastr.success(this.labelMessages.delete_success_msg);
    this.commonService.showModalValidate(this.labelMessages.delete_success_msg,'',this.messageLabel.static_messages.info, this.labelMessages.delete_success_msg);
  }

  deleteWhereConditionForPageWorkflow(cIndex: any, wIndex: any) {
    const whereCondition = <FormArray>this.pageWorkflowForm.get('selectedColumns')['controls'][cIndex].get('whereCondition');
    whereCondition.removeAt(wIndex);
    whereCondition.updateValueAndValidity();
    this.loadSqlStatement(this.pageWorkflowForm.get('selectedColumns')['controls'][cIndex], cIndex);
  //  this.toastr.success(this.labelMessages.delete_success_msg);
   this.commonService.showModalValidate(this.labelMessages.delete_success_msg,'',this.messageLabel.static_messages.info, this.labelMessages.delete_success_msg);
  }

  getTableName() {
    this.commonService.getTableDetails(this.pageId).subscribe((data: any) => {
      if (data['table'].length > 0) {
        this.tableName = data['table'][0].gstibo_table_name;
      }
    });
  }

  loadSqlStatement(form: any, cIndex: any) {
    const tblR = form.controls.whereCondition;
    this.generatedSqlQuery = '';
    let whereCondition = '';
    let prevColumn = '';
    tblR.value.forEach((ele: any, index: any) => {
      this.generatedSqlQuery = `${'select * from'} ${this.tableName}`;
      prevColumn = ele.columnName;
    });
    const whrCn = form.controls.whereCondition;
    whrCn.value.forEach((ele: any, indexX: any) => {
      let qrCondition = getWhereOperator(ele.operator);
      let condition = getAndOrOperator(ele.condition);
      if (indexX == 0) {
        whereCondition += ` ${'where'} ${ele.columnName} ${qrCondition} '${(ele.value == null ? '' : ele.value)}' ${condition} `;
      } else {
        whereCondition += `${ele.columnName} ${qrCondition} '${(ele.value == null ? '' : ele.value)}' ${condition} `;
      }
    });
    this.generatedSqlQuery += whereCondition;
    const selectedColumns = this.pageWorkflowForm.get('selectedColumns')['controls'][cIndex];
    selectedColumns.patchValue({
      sqlQuery: this.generatedSqlQuery
    });
    this.commonService.ogLog("Sel cols:", this.pageWorkflowForm.get('selectedColumns')['controls'][cIndex]);
  }

  addPageWorkflow() {
    const selectedColumns = <FormArray>this.pageWorkflowForm.get('selectedColumns');
    selectedColumns.push(this.formBuilder.group({
      controlName: null,
      actionName: null,
      sqlQuery: null,
      whereCondition: this.formBuilder.array([])
    }));
  }

  addWhereConditionForPageWorkflow(cIndex: any) {
    const whereCondition = <FormArray>this.pageWorkflowForm.get('selectedColumns')['controls'][cIndex].get('whereCondition');
    whereCondition.push(this.InitializeWhereCondition());
  }

  loadDynamicTables() {
    this.dynamicTableList = [];
    if (this.isSuperaDmin) {
      this.commonService.getMailMergeTableListForSuperAdmin(this.dbPath).subscribe((data: any) => {
        if (isData(data)) {
          let datas = data['table'];
          datas.forEach((el: any) => {
            this.dynamicTableList.push({
              id: el.gstibo_table_name,
              name: el.gstibo_table_name
            });
          });
          this.dynamicTableList.push({
            id: 'gstibo_dev_account',
            name: 'gstibo_dev_account'
          });
        }
      });
    } else {
      this.commonService.getMailMergeTableList().subscribe((data: any) => {
        if (isData(data)) {
          let datas = data['table'];
          datas.forEach((el: any) => {
            this.dynamicTableList.push({
              id: el.gstibo_table_name,
              name: el.gstibo_table_name
            });
          });
          this.dynamicTableList.push({
            id: 'gstibo_dev_account',
            name: 'gstibo_dev_account'
          });
        }
      });
    }
  }

  loadAllColumns(index: any) {
    const tblR = this.pageWorkflowForm.get('selectedColumns')['controls'][index].get('whereCondition')['controls'];
    this.pvAllColumns = [];
    for (let i = 0; i < tblR.length; i++) {
      if (this.pvColumnsList[i]) {
        this.pvColumnsList[i].forEach((data: any) => {
          this.pvAllColumns.push({
            id: data.id,
            name: data.name
          });
        });
        this.commonService.ogLog("this.pvcolumns 11:", this.pvAllColumns);
      }
    }
  }

  getColumnFromTable() {
    this.pageDetails = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!);
    const pageId = this.pageDetails.pageId;
    this.commonService.getTableDetails(pageId).subscribe((data: any) => {
      if (data['table'].length > 0) {
        const tableName = data['table'][0].gstibo_table_name;
        let columnData = [];
        if (this.isSuperaDmin) {
          this.commonService.getColumnsFromTableForSuperAdmin(this.dbPath, tableName).subscribe((data: any) => {
            if (isData(data)) {
              let datas = data['table'];
              datas.forEach((ele: any) => {
                this.pvAllColumns.push({
                  id: ele.column_name,
                  name: ele.column_name
                });
              });
            }
          });
        } else {
          this.commonService.getColumnsFromTable(tableName).subscribe((data: any) => {
            if (isData(data)) {
              let datas = data['table'];
              datas.forEach((ele: any) => {
                this.pvAllColumns.push({
                  id: ele.column_name,
                  name: ele.column_name
                });
              });
            }
          });
        }
      }
    }, error => {
      console.error('getTableDetails Error:', error);
    });

  }

  saveUserWorkFlowData(pageWorkFlowForm: any) {
    let retval = 0;
    // if (isNullOrUndefined(pageWorkFlowForm.displayName) || pageWorkFlowForm.displayName == '') {
    //   this.toastr.error(this.labelMessages.displayname_missing_message);
    //   retval = 2;
    // }
    // else if (isNullOrUndefined(pageWorkFlowForm.pageType) || pageWorkFlowForm.pageType == '1') {
    //   this.toastr.error(this.labelMessages.pageType_missing_message);
    //   retval = 2;
    // }
    // if (pageWorkFlowForm.displayName != '') {
    this.commonService.saveUserWorkflow(this.pageId, pageWorkFlowForm, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((data: any) => {
      if (isData(data)) {
        retval = data['table'][0].retval;
      }
    });
    // }
    return retval;
  }

  savePageWorkflowData(pageWorkflowValues: { selectedColumns: any; }, pageId: number, tableName: string) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    const selectedColumns = pageWorkflowValues.selectedColumns;
    // if (selectedColumns.length > 0) {
    //   if (selectedColumns[0].controlName == null) {
    //     this.toastr.error(this.labelMessages.error_message);
    //     return;
    //   }
    // }
    if (selectedColumns.length > 0 && selectedColumns[0].controlName != null) {
      this.commonService.deletePageWorkflow(dbFullPath, pageId).subscribe(datawd => {

      },
        error => {
          console.log('deletePageWorkflow Error:', error);
        });
      this.commonService.deletePageWorkflowAction(dbFullPath, pageId).subscribe((data: any) => {
      });
      this.commonService.deletePageWorkflowCondition(dbFullPath, pageId).subscribe(datacondition => {
      });

      this.commonService.savePageWorkflow(
        dbFullPath,
        pageId,
        tableName,
        this.commonService.getUserCredentials(KEYS.credential_account_id)
      ).subscribe((dataw: any) => {
        if (isData(dataw)) {
          let workflowid = dataw['table'][0].workflowid;
          this.commonService.ogLog("Selected Columns:", selectedColumns);
          selectedColumns.forEach((ele: any) => {
            let whereCondition = ele.whereCondition;
            if (ele.sqlQuery.indexOf("'") !== -1) {
              ele.sqlQuery = ele.sqlQuery.split("'").join("~");
            }
            this.commonService.savePageWorkflowAction(
              dbFullPath,
              pageId,
              workflowid,
              ele.controlName,
              ele.actionName,
              ele.sqlQuery
            ).subscribe((datas: any) => {
              if (isData(datas)) {
                let actionid = datas['table'][0].actionid;
                whereCondition.forEach((ele: any) => {
                  this.commonService.savePageWorkflowCondition(
                    dbFullPath,
                    pageId,
                    workflowid,
                    actionid,
                    ele.columnName,
                    ele.operator,
                    ele.value,
                    ele.condition
                  ).subscribe((data: any) => {
                  },
                    error => {
                      console.log('savePageWorkflowCondition Error:', error);
                    });
                });
              }
            },
              error => {
                console.log('addPageValidationCondition Error:', error);
              });
          });
        }

      },
        error => {
          console.log('savePageWorkflow Error:', error);
        });
    }
    let saveUserWorkflow = 0;
    saveUserWorkflow = this.saveUserWorkFlowData(this.pageWorkflowForm.value);
    this.saveOutlookWorkFlowData(this.pageWorkflowForm.value);
    // if (saveUserWorkflow != 2) {
    //   this.toastr.success(this.labelMessages.save_success_msg);
    //   this.modalRef.hide();
    // }
    this.saveMailMergeSettings();

    //this.toastr.success(this.labelMessages.save_success_msg);
     this.commonService.showModalValidate(this.labelMessages.save_success_msg,'',this.messageLabel.static_messages.info, this.labelMessages.save_success_msg);
    this.modalRef.hide();
  }

  loadUserWorkflow() {
    this.saveNextPageFlag = 0;
    this.commonService.getUserWorkflow(this.pageId).subscribe((data: any) => {
      if (isData(data)) {
        if (!isBlank(data['table'])) {
          data['table'].forEach((ele: any) => {
            if (ele.gstibo_save_to_next == 1) {
              this.saveNextPageFlag = 1;
            }
            this.pageWorkflowForm.patchValue
              ({
                displayName: ele.gstibo_display_name,
                isFirstPage: (ele.gstibo_is_first_page == 1 ? 'true' : 'false'),
                pageType: ele.gstibo_page_type,
                saveNextPage: (ele.gstibo_save_to_next == 1 ? 'true' : 'false'),
                nextPageId: ele.gstibo_next_page_id,
                lnkTableName: ele.gstibo_lnktableName,
                columnName: ele.gstibo_selcolName,
                iseCabinetPage: ele.gstibo_is_ecabinet == 1 ? 'true' : 'false',
                applyuserrights: (ele.gstibo_apply_user_rights == 1 ? 'true' : 'false')
              });
            this.loadSelTableColumns();
          });
        }
      }
    });
  }

  loadPageWorkflow() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    let getPageWorkflow, getPageAction, getPageCondition;
    this.getColumnFromTable();
    const selectedColumns = <FormArray>this.pageWorkflowForm.get('selectedColumns');
    selectedColumns.clear();
    selectedColumns.updateValueAndValidity();
    getPageWorkflow = this.commonService.getPageWorkflow(dbFullPath, this.pageId);
    this.commonService.ogLog("Workflow details:", getPageWorkflow);
    getPageAction = this.commonService.getPageWorkflowAction(dbFullPath, this.pageId);
    this.commonService.ogLog("Workflow details:", getPageWorkflow);
    getPageCondition = this.commonService.getPageWorkflowCondition(dbFullPath, this.pageId, 1);
    forkJoin(getPageAction, getPageCondition).subscribe((data: any) => {
      if (data.length > 0) {
        if (!isBlank(data[0]['table'])) {
          this.commonService.ogLog("first table:", data[0]['table']);
          data[0]['table'].forEach((ele: any, index: any) => {
            selectedColumns.push(this.formBuilder.group({
              controlName: ele.gstibo_input_id,
              actionName: ele.gstibo_action,
              sqlQuery: ele.gstibo_where_condition,
              whereCondition: this.formBuilder.array([])
            }));
            this.commonService.ogLog("Selected Columns:", selectedColumns);
            const whereCondition = <FormArray>this.pageWorkflowForm.get('selectedColumns')['controls'][index].get('whereCondition');
            whereCondition.clear();
            whereCondition.updateValueAndValidity();
            if (!isBlank(data[1]['table'])) {
              data[1]['table'].forEach((ele: any) => {
                whereCondition.push(this.formBuilder.group({
                  columnName: ele.gstibo_column_name,
                  operator: ele.gstibo_operator,
                  value: ele.gstibo_value,
                  condition: ele.gstibo_condition
                }));
              });
            }
          });
        } else {
          selectedColumns.push(this.formBuilder.group({
            controlName: null,
            actionName: null,
            sqlQuery: [null],
            whereCondition: this.formBuilder.array(['', Validators.required])
          }));
        }
      }
    },
      error => {
        console.log('loadPageWorkflow Error:', error);
      });
  }

  loadAllData() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.getColumnFromTable();
    this.actionTypeOptions = actionTypeOptions;
    const selectedColumns = <FormArray>this.pageWorkflowForm.get('selectedColumns');
    selectedColumns.clear();
    selectedColumns.updateValueAndValidity();
    this.commonService.getPageWorkflowAction(dbFullPath, this.pageId).subscribe((data: any) => {
      if (isData(data)) {
        let datas = data['table'];
        datas.forEach((ele: any, index: any) => {
          if (ele.gstibo_where_condition.indexOf("~") !== -1) {
            ele.gstibo_where_condition = ele.gstibo_where_condition.split("~").join("'");
          }

          const whereCondition = <FormArray>this.pageWorkflowForm.get('selectedColumns')['controls'][index].get('whereCondition');
          whereCondition.clear();
          whereCondition.updateValueAndValidity();
          this.commonService.getPageWorkflowCondition(dbFullPath, this.pageId, ele.gstibo_page_workflow_action_id).subscribe((dataCondition: any) => {
            if (isData(dataCondition)) {
              if (!isBlank(dataCondition['table'])) {
                dataCondition['table'].forEach((ele: any) => {
                  whereCondition.push(this.formBuilder.group({
                    columnName: ele.gstibo_column_name,
                    operator: ele.gstibo_operator,
                    value: ele.gstibo_value,
                    condition: ele.gstibo_condition
                  }));
                });
              }
            }
          });
        });
      }
      else {
        selectedColumns.push(this.formBuilder.group({
          controlName: null,
          actionName: null,
          sqlQuery: [null],
          whereCondition: this.formBuilder.array([])
        }));
        this.addWhereConditionForPageWorkflow(0);
      }
    });
  }

  onControlchange(event: any, index: any) {
    const selectedColumns = this.pageWorkflowForm.value.selectedColumns;
    if (selectedColumns != null && selectedColumns.length > 0) {
      selectedColumns.forEach((element: any) => {
        if (element.actionName != null) {
          if (element.controlName == event['inputid']) {
            const selectedColumns = <FormArray>this.pageWorkflowForm.get('selectedColumns');
            this.commonService.ogLog("Index:", selectedColumns.at(index));
            //selectedColumns.at(index)['controlName']=null;
            selectedColumns.removeAt(index);
            selectedColumns.updateValueAndValidity();
            this.commonService.ogLog("Array:", selectedColumns);
           // this.toastr.warning(this.labelMessages.control_exists_msg);
             this.commonService.showModalValidate(this.labelMessages.control_exists_msg,'',this.messageLabel.static_messages.warning, this.labelMessages.control_exists_msg);
            return;
          }
        }
      });
    }
  }

  getMenusByModuleId() {
    this.allPageList = [];
    this.commonService.getMenusByModuleId(this.pageId).subscribe((data: any) => {
      if (data['table'].length > 0) {
        this.allPageList = data['table'];
      }
    });
  }

  onSaveNextPageChange(evnt: any) {
    if (evnt.id == 'true')
      this.saveNextPageFlag = 1;
    else
      this.saveNextPageFlag = 0;
  }
  loadTableList() {
    this.dynamicTables = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadDynamicTables(dbFullPath).subscribe((data: any) => {
      if (isData(data)) {
        this.dynamicTables = data['table'];
      }
    });
  }

  loadSelTableColumns() {
    this.tableColumns = [];
    const dbPath = JSON.parse(sessionStorage.getItem(KEYS.customerDbPath)!);
    this.commonService.getTableColumns(dbPath, this.pageWorkflowForm.value.lnkTableName).subscribe((data: any) => {
      if (isData(data)) {
        this.tableColumns = data['table'];
      }
    });
  }

  //#region mailmergecontent

  InitializeInnerArraysMM() {
    return this.formBuilder.group({
      tableName: null,
      lnkColName: null,
      //mailmergecontent: this.formBuilder.array([])
      mailmergecontent: this.formBuilder.array([this.InitializeMailMergeContent()])
    });
  }

  getMailMergeContent(form: any) {
    return form.controls.mailmergecontent.controls;
  }

  InitializeMailMergeContent() {
    return this.formBuilder.group({
      columnName: null,
      content: null,
      gstibo_columns: this.formBuilder.array([])
    });
  }

  addMailMergeSettings() {
    const selectedColumns = <FormArray>this.pageWorkflowForm.get('selectedColumnsMM');
    selectedColumns.push(this.formBuilder.group({
      tableName: null,
      lnkColName: null,
      mailmergecontent: this.formBuilder.array([this.InitializeMailMergeContent()])
    }));
  }

  addContent(cIndex: any) {
    const mailmergecontent = <FormArray>this.pageWorkflowForm.get('selectedColumnsMM')['controls'][cIndex].get('mailmergecontent');
    mailmergecontent.push(this.InitializeMailMergeContent());
  }

  getPageTable(index: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.mm_columns_list[index] = [];
    let tableName = this.pageWorkflowForm['controls']['selectedColumnsMM']['controls'][index].get('tableName').value;
    let mailMergeContent = this.pageWorkflowForm['controls']['selectedColumnsMM']['controls'][index].get('mailmergecontent').value
    if (tableName != '') {
      this.commonService.getSelectedTableColumn(dbFullPath, tableName, '').subscribe((data: any) => {
        if (isData(data)) {
          mailMergeContent.forEach((element: any, idx: any) => {
            element.gstibo_columns = data['table'];
          });
          this.mm_columns_list[index] = data['table'];
        } else {
          this.commonService.ogLog('column data not available:');
        }
      },
        error => {
          console.log('usp_button_action_detils Error:', error);
        });
      this.loadSqlStatementMM();

    } else {
      console.log('table name is empty');
    }
  }

  getSelTableCols() {
    let tableName = this.pageWorkflowForm.value.parenttableName;
    this.parent_columns_list = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    if (tableName != '') {
      this.commonService.getSelectedTableColumn(dbFullPath, tableName, '').subscribe((data: any) => {
        if (isData(data)) {
          this.parent_columns_list = data['table'];
        } else {
          this.commonService.ogLog('column data not available:');
        }
      },
        error => {
          console.log('usp_button_action_detils Error:', error);
        });

    } else {
      this.commonService.ogLog('table name is empty');
    }
  }


  saveMailMergeSettings() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.deleteMMContentSettingsDetails(dbFullPath, this.pageId).subscribe
      (deldata => {
        let control = this.pageWorkflowForm['controls']['selectedColumnsMM']['controls'];
        control.forEach((element: any) => {
          let mailmergearray = element.value['mailmergecontent'];
          let sqlQuery = this.pageWorkflowForm.value.sqlQueryMM;
          let parentTbl = this.pageWorkflowForm.value.parenttableName;
          let parentTblPrCol = this.pageWorkflowForm.value.parentPrColName;
          this.commonService.insertMMContentSettings(dbFullPath, this.pageId, this.commonService.getUserCredentials(KEYS.credential_account_id),
            element.value['tableName'], element.value['lnkColName'], sqlQuery, parentTbl, parentTblPrCol, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe
            ((data: any) => {
              let mailmergeid = data['table'][0].mailmergeid;
              mailmergearray.forEach((ele: any) => {
                this.commonService.insertMMContentSettingsDetails(dbFullPath, mailmergeid, this.pageId,
                  ele.columnName, ele.content, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe
                  (datadetails => {

                  });
              });
            });
        });
      });
  }

  deleteMailMergeMain(cIndex: any) {
    const selectedColumnsMM = <FormArray>this.pageWorkflowForm.get('selectedColumnsMM');
    selectedColumnsMM.removeAt(cIndex);
    selectedColumnsMM.updateValueAndValidity();
    this.loadSqlStatementMM();
  }

  deleteContent(cIndex: any, wIndex: any) {
    const mailmergecontent = <FormArray>this.pageWorkflowForm.get('selectedColumnsMM')['controls'][cIndex].get('mailmergecontent');
    mailmergecontent.removeAt(wIndex);
    mailmergecontent.updateValueAndValidity();
    this.loadSqlStatementMM();
    //this.toastr.success(this.labelMessages.delete_success_msg);
  }

  loadMailMergeData() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';

    const selectedColumnsMM = <FormArray>this.pageWorkflowForm.get('selectedColumnsMM');
    selectedColumnsMM.clear();
    selectedColumnsMM.updateValueAndValidity();
    this.commonService.getMailmergeSettings(dbFullPath, this.pageId).subscribe((data: any) => {
      if (isData(data)) {
        let datas = data['table'];
        this.generatedSqlQueryMM = data['table'][0].gstibo_sql_query;
        this.pageWorkflowForm.patchValue({
          sqlQueryMM: this.generatedSqlQueryMM,
          parenttableName: data['table'][0].gstibo_parent_tbl,
          parentPrColName: data['table'][0].gstibo_parent_tblPrcol
        });
        datas.forEach((ele: any, index: any) => {
          this.commonService.getSelectedTableColumn(dbFullPath, ele.gstibo_tbl_name, '').subscribe((datacols: any) => {
            if (isData(datacols)) {
              this.mm_columns_list[index] = datacols['table'];
            }
          });
          selectedColumnsMM.push(this.formBuilder.group({
            tableName: ele.gstibo_tbl_name,
            lnkColName: ele.gstibo_linking_col,
            mailmergecontent: this.formBuilder.array([])
          }));

          const mailmergecontent = <FormArray>this.pageWorkflowForm.get('selectedColumnsMM')['controls'][index].get('mailmergecontent');
          mailmergecontent.clear();
          mailmergecontent.updateValueAndValidity();
          this.commonService.getMailmergeSettingsDetails(dbFullPath, ele.gstibo_mailmerge_id).subscribe((dataCondition: any) => {
            if (isData(dataCondition)) {
              if (!isBlank(dataCondition['table'])) {
                dataCondition['table'].forEach((ele: any) => {
                  mailmergecontent.push(this.formBuilder.group({
                    columnName: ele.gstibo_col_name,
                    content: ele.gstibo_col_replace_content
                  }));
                });
              }
            }
          });
        });
      }
      else {
        selectedColumnsMM.push(this.formBuilder.group({
          tableName: null,
          lnkColName: null,
          mailmergecontent: this.formBuilder.array([])
        }));
        this.addContent(0);
      }
    });
  }

  loadSqlStatementMM() {
    this.generatedSqlQueryMM = '';
    this.pageWorkflowForm.patchValue({
      sqlQueryMM: this.generatedSqlQueryMM
    });
    const tblR = this.pageWorkflowForm.controls.selectedColumnsMM;
    let selectstmt = 'SELECT *';
    let fromstmt = ' FROM ' + this.pageTable;
    let frmwhere = '';
    let parentTblPrCol = this.pageWorkflowForm.value.parentPrColName;
    tblR.value.forEach((ele: any, index: any) => {
      frmwhere += ` ${'INNER JOIN '} ${ele.tableName} ${'ON '} ${this.pageTable} ${'.'} ${parentTblPrCol}
           ${' = '} ${ele.tableName}${'.'} ${ele.lnkColName}`;
      const tblRMM = ele.mailmergecontent;
      ele.mailmergecontent.forEach((eleMM: any, index: any) => {
        if (eleMM.columnName != null) {
          selectstmt += `${','} ${ele.tableName}${'.'}${eleMM.columnName}`;
        }
      });
    });
    this.generatedSqlQueryMM = selectstmt + fromstmt + frmwhere;
    this.pageWorkflowForm.patchValue({
      sqlQueryMM: this.generatedSqlQueryMM
    });
  }
  //#endregion
  get f() { return this.pageWorkflowForm.controls; }
  saveOutlookWorkFlowData(pageWorkFlowForm: any) {
    this.commonService.saveOutlookWorkflow(this.pageId, pageWorkFlowForm.isOutlookPage).subscribe((data: any) => {
      if (isData(data)) {
      }
    });
  }
  loadoutlookworkflow() {
    //throw new Error("Method not implemented.");
    this.commonService.getOutlookWorkflow(this.pageId).subscribe((data: any) => {
      if (isData(data)) {
        if (!isBlank(data['table'])) {
          data['table'].forEach((ele: any) => {
            this.pageWorkflowForm.patchValue
              ({
                isOutlookPage: (ele.gstibo_is_outlook == 1 ? 'true' : 'false')
              });
          });
        }
      }
    });
  }


}
